import {
  REQUEST_IMAGES,
  RECEIVE_IMAGES,
  FAILED_RECEIVE_IMAGES
} from '../actions/images'

/**
 * Function returns the new state based on the
 * given action.
 *
 * @param {object} state
 * @param {object} action
 */
const images = ( state = {}, action ) => {
  switch ( action.type ) {
    case REQUEST_IMAGES:
      return {
        ...state,
        isFetching: true
      }
    case RECEIVE_IMAGES:
      return {
        ...state,
        isFetching: false,
        data: action.data
      }
    case FAILED_RECEIVE_IMAGES:
      return {
        ...state,
        isFetching: false
      }
    default:
      return state
  }
}


export default images
